import { PublicApiClient } from '@guiker/propsharing-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const usePublicApiClient = useAuthenticatedApiClient(PublicApiClient)
